import InfoCircle from '../src/InfoCircle/index';
export default InfoCircle;
